export const CREATE_OPPORTUNITY = 'create_opportunity'
export const UPDATE_OPPORTUNITY = 'update_opportunity'
export const OPPORTUNITY_LIST = 'opportunity_list'
export const OPPORTUNITY_QUESTION = 'opportunity_question'
export const GET_OPPORTUNITY_BY_ID = 'get_opportunity_by_id'
export const FILTER_CONTENT = 'filter_content'
export const PROPOSAL_COMMERCIAL_CLOSURE = 'proposal_commercial-closure'